// import Vue from "vue";
import { getBeneficiaries } from "@/shared/api/bankService";
import { defineStore } from "pinia";
import { handleError } from "@/shared/storeHelper";
import { BeneficiaryState, FetchState, Beneficiary } from "@/shared/types";
import _ from "lodash";


export const initialState: BeneficiaryState = {
    beneficiaries: [],
    fetchState: FetchState.Uninitialized
};

export const useBeneficiaryStore = defineStore("beneficiary", {
    state: (): BeneficiaryState => (_.cloneDeep(initialState)),
    getters: {
        isBeneficiariesLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        loadBeneficiaries  (args?: { username: string, partnerId: number} ) {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            this.fetchState = FetchState.Loading;

            return getBeneficiaries(args)
            .then(response => {
                this.beneficiaries = response.data.beneficiaries.reduce((accumulator, current) => {
                    accumulator[current.id] = current;
                    return accumulator;
                }, {});
            })
            .catch(err => {
                handleError({error: err, rethrow: false });
            })
            .finally(() => {
                this.fetchState = FetchState.Loaded;
            });
        }
    }
});